
import Button from '@/components/base/Button';

export default function AboutSection() {
  return (
    <section className="py-20 bg-pink-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in-left">
            <h2 className="text-4xl lg:text-5xl font-bold text-black font-serif mb-6 animate-slide-right">
              About Forever Young
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed animate-fade-in delay-300">
              Located in the heart of Calgary, Forever Young Laser Clinic & Spa has been transforming 
              lives through advanced beauty and wellness treatments for over a decade. Our team of 
              certified professionals combines cutting-edge technology with personalized care.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed animate-fade-in delay-500">
              We believe that everyone deserves to feel confident and beautiful in their own skin. 
              That's why we offer a comprehensive range of services designed to enhance your natural 
              beauty and promote overall wellness.
            </p>
            <div className="space-y-4 animate-fade-in delay-700">
              <div className="flex items-center space-x-3 transform hover:translate-x-2 transition-transform duration-300">
                <div className="w-2 h-2 bg-black rounded-full animate-pulse"></div>
                <span className="text-gray-700">Certified &amp; Licensed Professionals</span>
              </div>
              <div className="flex items-center space-x-3 transform hover:translate-x-2 transition-transform duration-300">
                <div className="w-2 h-2 bg-black rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
                <span className="text-gray-700">State-of-the-Art Equipment</span>
              </div>
              <div className="flex items-center space-x-3 transform hover:translate-x-2 transition-transform duration-300">
                <div className="w-2 h-2 bg-black rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
                <span className="text-gray-700">Personalized Treatment Plans</span>
              </div>
            </div>
          </div>
          
          <div className="animate-fade-in-right">
            <div className="relative group">
              <img
                src="https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/7ec135ec6e6ac9d2867b99814a3b45d2.png"
                alt="Forever Young Spa Interior"
                className="rounded-lg shadow-lg w-full transform group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 rounded-lg transition-all duration-500"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
